<template>
  <v-sheet class="slider-wrapper elevation-1">
    <v-slide-group
      v-model="model"
      class="slider-group"
      show-arrows="always"
      center-active
    >
      <template v-slot:prev>
        <v-btn icon small class="slider-nav-btn"><v-icon>mdi-chevron-right</v-icon></v-btn>
      </template>
      <template v-slot:next>
        <v-btn icon small class="slider-nav-btn"><v-icon>mdi-chevron-left</v-icon></v-btn>
      </template>

      <v-slide-item
        v-for="item in visibleMarkets"
        :key="item.value"
        :value="item.value"
        class="slider-item"
        v-slot="{ active, toggle }"
      >
        <div
          class="custom-card-wrapper"
          :class="{
            'is-active': active,
            'is-inactive': model !== null && !active,
            'disabled-item': item.status === 'deactive'
          }"
          @click="item.status !== 'deactive' && handleSelection(item, toggle)"
        >
          <!-- بج اختصاصی فقط برای مواردی که comingSoon دارند -->
          <span v-if="item.comingSoon" class="coming-soon-badge">
            {{ item.badgeText || 'به‌زودی' }}
          </span>

          <v-avatar v-if="active" size="20" class="selected-check-badge">
            <v-icon size="12" color="white">mdi-check</v-icon>
          </v-avatar>

          <div
            class="market-card"
            :style="{
              background: `linear-gradient(135deg, ${item.colors[0]} 0%, ${item.colors[1]} 60%, ${item.colors[2]} 100%)`
            }"
          >
            <div class="main-circle">
              <div class="circle-inner">
                <div
                  v-if="item.img"
                  class="brand-icon-mask"
                  :style="{
                    backgroundColor: (item.attrs && item.attrs.hover) ? item.attrs.hover : item.colors[0],
                    maskImage: `url(${item.img})`,
                    WebkitMaskImage: `url(${item.img})`,
                    transform: 'scale(1.2)'
                  }"
                ></div>
                <v-icon v-else :color="item.colors[0]" size="20">
                  mdi-{{ item.icon || 'storefront' }}
                </v-icon>
              </div>
            </div>

            <div class="text-pill">
              <span class="text-title" :style="{ color: item.colors[0] }">
                {{ item.name }}
              </span>
            </div>
          </div>
        </div>
      </v-slide-item>
    </v-slide-group>
  </v-sheet>
</template>

<script>
export default {
  name: "MarketplaceCardSlider",
  props: {
    value: {
      type: [Object, String, Number],
      default: null,
    },
    onlyActive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      marketplaces: [],
      model: null,
      loading: false,
    };
  },
  computed: {
    visibleMarkets() {
      if (!this.onlyActive) return this.marketplaces;
      return this.marketplaces.filter((item) => item.status !== "deactive");
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        if (!newVal) {
          this.model = null;
          return;
        }
        // پشتیبانی از پاس دادن ID یا Object
        this.model = typeof newVal === 'object' ? (newVal.store_id || newVal.value || newVal.id) : newVal;
      },
    },
  },
  async mounted() {
    await this.fetchAndPrepareMarkets();
  },
  methods: {
    handleSelection(item, toggle) {
      toggle();
      const payload = {
        store_id: item.store_id || item.id,
        id: item.store_id || item.id,
        title: item.name,
        name: item.name,
        type: item.type || item.value
      };
      this.$emit("input", payload);
      this.$emit("selectMarket", payload);
    },

    getDefualtPlatformTemplates() {
      return {
        general_settings: {
          name: "تنظیمات کلی",
          img: "/media/socialIcon/40icon/pr/tools.svg",
          icon: "cog-outline",
          colors: ["#5c6bc0", "#3949ab", "#e8eaf6"],
          status: "active",
        },
        general_placemarket: {
          name: "تنوع محصول من",
          img: "/media/socialIcon/40icon/pr/variant.svg",
          icon: "box-glove",
          colors: ["#5C6C02", "#7FAB39", "#e8eaf6"],
          status: "active",
        },

        general_buyers: {
          name: "کل خریداران",
          img: "/media/socialIcon/40icon/pr/buyers.svg",
          icon: "account-box",
          colors: ["#5CC09FC5", "#39ABA0", "#e8eaf6"],
          status: "active",
        },
        digikala: {
          name: "دیجی‌کالا",
          img: "/media/socialIcon/40icon/pr/digikala.svg",
          colors: ["#ef394e", "#f25d6e", "#ffebee"],
          status: "active",
        },
        divar: {
          name: "دیوار",
          img: "/media/socialIcon/40icon/pr/divar.svg",
          icon: "post-outline",
          colors: ["#a62626", "#c62828", "#ffebee"],
          status: "active",
        },
        physical_store: {
          name: "فروشگاه فیزیکی",
          img: null,
          icon: "store-24-hour",
          colors: ["#36E71B", "#094D04", "#98F3C1"],
          status: "active",
        },
        woocommerce: {
          name: "ووکامرس",
          img: "/media/socialIcon/40icon/pr/samsung.svg",
          icon: "shopping-outline",
          colors: ["#7f54b3", "#96588a", "#ede7f6"],
          status: "active",
        },
        basalam: {
          name: "باسلام",
          img: "/media/socialIcon/40icon/pr/basalam.svg",
          colors: ["#FF5C39", "#ff7a5c", "#ffede9"],
          status: "deactive",
          comingSoon: true,
        },
        torob: {
          name: "ترب",
          img: "/media/socialIcon/40icon/pr/torob.svg",
          colors: ["#d62020", "#e53935", "#ffebee"],
          status: "deactive",
        },
        snappshop: {
          name: "اسنپ شاپ",
          img: "/media/socialIcon/40icon/pr/snappshop.svg",
          colors: ["#B400AE", "#c92bb9", "#f9e6f8"],
          status: "deactive",
        },
        emalls: {
          name: "ایمالز",
          img: "/media/socialIcon/40icon/pr/Emalls.svg",
          colors: ["#fd564a", "#ff7368", "#ffebe9"],
          status: "deactive",
        },
        technolife: {
          name: "تکنولایف",
          img: "/media/socialIcon/40icon/pr/technolife.svg",
          colors: ["#26487e", "#3a5f9c", "#e7ebf2"],
          status: "deactive",
        },
        sheypoor: {
          name: "شیپور",
          img: "/media/socialIcon/40icon/pr/sheypour.svg",
          icon: "bullhorn",
          colors: ["#00838f", "#00acc1", "#e0f7fa"],
          status: "deactive",
        },
      };
    },

    async fetchAndPrepareMarkets() {
      this.loading = true;
      const templates = this.getDefualtPlatformTemplates();

      try {
        const res = await this.$api.get("v1/store/lists");
        const rawList = res.data?.data || res.data || [];

        const list = [];

        // اگر صفحه تنظیمات کلی بود
        if (this.$route.name === "admin.sellsettings") {
          list.push({
            ...templates.general_settings,
            store_id: null,
            id: null,
            value: 'general_settings',
            type: 'general_settings'
          });
        }
        if (this.$route.name === "admin.buyers") {
          list.push({
            ...templates.general_buyers,
            store_id: null,
            id: null,
            value: 'general_buyers',
            type: 'general_buyers'
          });
        }
        if (this.$route.name === "admin.placemarketing") {
          list.push({
            ...templates.general_placemarket,
            store_id: null,
            id: null,
            value: 'general_placemarket',
            type: 'general_placemarket'
          });
        }

        // مپ کردن داده‌های دریافتی از سرور با استایل‌های از پیش تعریف شده
        rawList.forEach((store) => {
          const tpl = templates[store.type] || {
            colors: ["#455a64", "#263238", "#cfd8dc"],
            icon: "storefront",
            name: store.type
          };

          list.push({
            ...tpl,
            name: store.title || store.name || tpl.name,
            store_id: store.id,
            id: store.id,
            value: store.id,
            type: store.type,
            status: "active"
          });
        });

        this.marketplaces = list;

        // انتخاب اولین آیتم در صورت عدم وجود مقدار پیش‌فرض
        if (this.value) {
          const targetId = typeof this.value === 'object' ? (this.value.store_id || this.value.id || this.value.value) : this.value;
          const found = this.marketplaces.find((m) => m.value === targetId);
          if (found) {
            this.model = found.value;
            this.handleSelection(found, () => {});
          }
        } else if (this.marketplaces.length > 0) {
          const first = this.marketplaces[0];
          this.model = first.value;
          this.handleSelection(first, () => {});
        }

      } catch (err) {
        console.error("خطا در لود فروشگاه‌ها:", err);
      } finally {
        this.loading = false;
      }
    }
  },
};
</script>

<style scoped>
.slider-wrapper {
  width: 100%;
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid #ebeef5;
  padding: 8px 4px 14px 4px;
}

.slider-group {
  width: 100%;
}

::v-deep .v-slide-group__wrapper {
  overflow-y: visible !important;
  padding-top: 24px !important;
}

::v-deep .v-slide-group__prev,
::v-deep .v-slide-group__next {
  min-width: 36px !important;
  flex: 0 0 36px;
}

.slider-nav-btn {
  background-color: #f5f6f8 !important;
  color: #606266 !important;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08) !important;
}

.slider-item {
  margin: 0 5px;
  position: relative;
  flex: 0 0 auto !important; /* جلوگیری از فشرده‌شدن و تغییر عرض آیتم */
}

.custom-card-wrapper {
  position: relative;
  width: 105px;
  height: 68px;
  cursor: pointer;
  border-radius: 6px;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  box-sizing: border-box;
}

.market-card {
  width: 100%;
  height: 100%;
  border-radius: 6px;
  position: relative;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding: 6px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
}

.coming-soon-badge {
  position: absolute;
  top: -6px;
  left: -4px;
  z-index: 10;
  background: linear-gradient(135deg, #ff9800, #f44336);
  color: white;
  font-size: 8px;
  font-weight: 700;
  padding: 1px 5px;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);
  line-height: 1.3;
}

.main-circle {
  position: absolute;
  top: -16px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 3;
  scale: 1.2;
}

.circle-inner {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #ffffff;
  border: 2px solid #ffffff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s ease;
}

.brand-icon-mask {
  width: 22px;
  height: 22px;
  mask-size: contain;
  -webkit-mask-size: contain;
  mask-repeat: no-repeat;
  -webkit-mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-position: center;
  display: block;
}

.text-pill {
  width: 100%;
  background: #ffffff;
  border-radius: 5px;
  padding: 3px 2px;
  text-align: center;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
}

.text-title {
  font-size: 12px;
  font-weight: 700;
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  user-select: none;
}

.custom-card-wrapper.is-active {
  transform: translateY(-2px) scale(1.02);
  z-index: 5;
}

.custom-card-wrapper.is-active .market-card {
  box-shadow: 0 0 0 2px #00c853, 0 4px 12px rgba(0, 200, 83, 0.25) !important;
}

.selected-check-badge {
  position: absolute;
  top: -6px;
  right: -4px;
  background-color: #00c853 !important;
  border: 1.5px solid #ffffff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  z-index: 10;
}

.custom-card-wrapper.disabled-item {
  opacity: 0.55 !important;
  filter: grayscale(25%);
  cursor: not-allowed !important;
}

.custom-card-wrapper.is-inactive {
  opacity: 0.6;
}

.custom-card-wrapper:hover:not(.disabled-item):not(.is-active) {
  transform: translateY(-2px);
  opacity: 0.95;
}
</style>
